module.exports = __webpack_public_path__ + "static/media/3.73a48b0d.png";